<template>
 <div class="content">
  <div class="zp-table-box1"><a style="margin-top: 10px" @click="open()" @mouseleave="close">{{this.times }}</a></div>
<!--   <div class="zp-table-box1"><a style="margin-top: 10px" @click="open()">{{this.times }}</a></div>-->
<!--<div class="zp-table-box"><a @click="open()">{{this.times }}</a></div>-->
   <show-dialog ref="showDialog"></show-dialog>
 </div>
</template>
<script>
import showDialog from "@/views/recruit/yuanDesc/showDialog";
export default {
  name: "zpContent",
  data() {
    return {
    };
  },
  props: {
    times: {
      type: String,
      default: "1",
    }
    ,
    date: {
      type: String,
      default: "0830",
    }
  },
  components:{showDialog},
  methods:{
    open(){
      this.$refs.showDialog.open(this.date);
    },

    close(){
      this.$refs.showDialog.close();
    }
  }
}
</script>

<style scoped lang="scss">
.content{
  position: relative;
}
.zp-table-box1{
  width: 100%;
  height: 40px;
  outline: 0.1px solid #C7D2F2;
  display: flex;
  justify-content: center;
}
</style>